import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { XIcon } from '@phosphor-icons/react'

interface TribeModalProps {
  show: boolean
  onClose: () => void
  onSubmit: (name: string) => Promise<boolean | void> | boolean | void
}

export const TribeModal = ({ show, onClose, onSubmit }: TribeModalProps) => {
  const [name, setName] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    if (!show) {
      setIsSubmitting(false)
      return
    }
    setName('')
  }, [show])

  const handleClose = () => {
    if (isSubmitting) return
    onClose()
  }

  const canSave = name.trim().length > 0

  const handleSubmit = async () => {
    if (!canSave || isSubmitting) return
    setIsSubmitting(true)
    try {
      const result = await onSubmit(name.trim())
      if (result === false) return
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="tribe-modal-dialog"
      contentClassName="tribe-modal-content"
    >
      <div className="tribe-modal">
        <div className="tribe-modal__header">
          <h2 className="tribe-modal__title">Add New Tribe</h2>
          <button
            className="tribe-modal__close"
            onClick={handleClose}
            aria-label="Close"
          >
            <XIcon size={20} weight="regular" />
          </button>
        </div>

        <div className="tribe-modal__content">
          <div className="tribe-modal__fields">
            <div className="tribe-modal__field">
              <label className="tribe-modal__label tribe-modal__label--required">
                Tribe Name
              </label>
              <input
                type="text"
                className="tribe-modal__input"
                placeholder="Enter tribe name"
                value={name}
                onChange={e => setName(e.target.value)}
                maxLength={25}
                autoFocus
              />
            </div>
          </div>

          <div className="tribe-modal__footer">
            <button
              className="tribe-modal__btn tribe-modal__btn--cancel"
              onClick={handleClose}
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              className="tribe-modal__btn tribe-modal__btn--save"
              onClick={handleSubmit}
              disabled={!canSave || isSubmitting}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default TribeModal
